module.exports = __webpack_public_path__ + "92b2c6e7de20fd2645f92dda13b87a55.png";